import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function RedirectIfAuthenticated({ Component }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // You can replace with a proper loading component
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <Component />;
}

export default RedirectIfAuthenticated;
